import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GENERIC_STATE_STATUS } from "../../../shared/enums";
import { AssessmentMatch } from "../../../model/assessment";

const initialState: {
  data: AssessmentMatch | null;
  status: GENERIC_STATE_STATUS;
  importStatus: GENERIC_STATE_STATUS;
  importError: string;
} = {
  status: GENERIC_STATE_STATUS.FULFILLED,
  data: null,
  importStatus: GENERIC_STATE_STATUS.FULFILLED,
  importError: "",
};
export const assessmentQuestionStore = createSlice({
  name: "match",
  initialState,
  reducers: {
    assessmentQuestionImportStart(state) {
      return {
        ...state,
        importStatus: GENERIC_STATE_STATUS.PENDING,
      };
    },
    assessmentQuestionImportSuccess(
      state,
      action: PayloadAction<AssessmentMatch>
    ) {
      const { payload } = action;
      return {
        ...state,
        data: payload,
        importStatus: GENERIC_STATE_STATUS.FULFILLED,
      };
    },
    assessmentQuestionImportFail(state, action: PayloadAction<string>) {
      const { payload } = action;
      return {
        ...state,
        importStatus: GENERIC_STATE_STATUS.REJECTED,
        importError: payload,
      };
    },
  },
});

export const {
  assessmentQuestionImportFail,
  assessmentQuestionImportStart,
  assessmentQuestionImportSuccess,
} = assessmentQuestionStore.actions;
